import "./products.css"
import ReactPaginate from "react-paginate";
import { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format"
import { useGlobalContext } from "../../context";
import Detailpro from "../detailpro/detailpro";
import { Link } from "react-router-dom";
import { handleGetData } from "../../requests/productRequests";

function Product() {
    //GLOBALCONTEXT-----
    const { handleShowDetail, setShowdetail, totalFilter } = useGlobalContext()
    //------------------
    //STATES-------------
    const [changeImage, setChangeImage] = useState(null)
    // ---------------------
    //PAGINATION-------------------
    const [data, setData] = useState([])
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [loader, setLoader] = useState(false)
    const itemsPerPage = 20;

    useEffect(async () => {
        setLoader(true)
        const { min, max, cat, search, color } = totalFilter
        try {
            const filteredData = await handleGetData(min, max, cat, search, color)
            setData(filteredData)
            setLoader(false)
        } catch (err) {
            console.log(err)
        }
    }, [totalFilter])
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
    };
    //--------------------------------

    return (
        <>

            <div className="products-component">
                <div className="products-component-container">
                    {
                        currentItems.length == 0 &&
                        <h1>محصولی یافت نشد</h1>
                    }
                    {
                        loader &&
                        <div className="loader-products">
                            <div className="loader"></div>
                        </div>
                    }
                    {currentItems.map((item, i) => {
                        return (
                            <div className="product" key={i}>
                                <div className={changeImage == i ? "image show" : "image"}>
                                    <img className={changeImage == i ? "pro-image show" : "pro-image"} onMouseEnter={() => setChangeImage(i)} onMouseLeave={() => setChangeImage(null)} src={changeImage == i ? item.img[1] : item.img[0]} alt="" />
                                    <button onClick={() => {
                                        handleShowDetail(item)
                                        setShowdetail(true)
                                    }}>نمایش سریع</button>
                                </div>
                                <div className="info">
                                    <Link to={`/product/${item.productCode}`} style={{ color: "black" }}>
                                        <div className="pro-brand"><span style={{ fontSize: "10px", color: "gray" }}>وست</span></div>
                                        <div className="code">
                                            <span>کد : </span>
                                            <span>{item.productCode}</span>
                                        </div>
                                        <div className="name"><span>{item.title}</span></div>
                                        <div className="price">
                                            <CurrencyFormat thousandSeparator={true}
                                                value={item.price}
                                                prefix="تومان"
                                                displayType="text">
                                            </CurrencyFormat>
                                        </div>
                                        <div className="sizes">
                                            <p style={{ fontSize: "10px" }}>سایز ها :</p>
                                            {
                                                item.sizes.map((size, i) => {
                                                    return (
                                                        <span key={i}
                                                            // onClick={() => {
                                                            //     handleShowDetail(item)
                                                            //     setShowdetail(true)
                                                            //     setSize(size)
                                                            //     setQtyInStore(item.store[i])
                                                            // }} 
                                                            className={item.instock[i] == 0 ? "size-none" : ""}>{size}</span>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='page'>
                    <ReactPaginate
                        breakLabel='...'
                        nextLabel='بعدی'
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={2}
                        pageCount={pageCount}
                        previousLabel='قبلی'
                        renderOnZeroPageCount={null}
                        containerClassName='pagination'
                        pageClassName='page-num'
                        previousLinkClassName='prev'
                        nextLinkClassName='next'
                        activeClassName='active'
                    />
                </div>
                <Detailpro />
            </div>
        </>
    )
}

export default Product;